const isCheckoutRegular = (checkoutType) => checkoutType === "regular";
const isCheckoutOffer = (checkoutType) => checkoutType === "offer";

export { isCheckoutRegular, isCheckoutOffer };
